export default function getTotalPriceFromAnalyticsPoints(points = []) {
  const addPointToTotal = (total, point) => {
    return total + Number.parseFloat(point.y);
  };
  const totalPrice = points.reduce(addPointToTotal, 0);
  return totalPrice;
}
